"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const core_1 = require("@bimser/core");
const actionTypes_1 = require("../actionTypes");
function openObjectExplorer() {
    const action = (0, core_1.createSyncAction)(actionTypes_1.OPEN, null);
    return action;
}
exports.default = openObjectExplorer;
//# sourceMappingURL=open.js.map